import { LegalLayout, LegalSection } from '../../components/legal/LegalLayout';

const tbd = <span className="italic text-black/45">(a confirmar na versão final)</span>;

export function PrivacyPolicyPage(): JSX.Element {
  return (
    <LegalLayout title="Política de Privacidade" updatedAt="(a definir na publicação)">
      <LegalSection title="1. Controlador e contato">
        <p>
          O controlador dos dados — razão social e CNPJ {tbd} — trata seus dados pessoais conforme
          esta Política. Para assuntos de privacidade, fale com o nosso encarregado (DPO) pelo canal{' '}
          {tbd}.
        </p>
      </LegalSection>

      <LegalSection title="2. Dados que coletamos no checkout">
        <ul className="list-disc space-y-1.5 pl-5">
          <li>Identificação e contato: nome, e-mail e telefone.</li>
          <li>Documento: CPF ou CNPJ (exigência do meio de pagamento e da emissão fiscal).</li>
          <li>
            Dados de pagamento (cartão): número, validade, código de segurança e nome do titular —
            apenas quando o método é cartão de crédito.
          </li>
          <li>Técnicos: endereço IP (prevenção a fraude) e dados mínimos de navegação.</li>
        </ul>
      </LegalSection>

      <LegalSection title="3. Como tratamos os dados do cartão">
        <p>
          Os dados do cartão são transmitidos por conexão criptografada (TLS) e encaminhados ao
          gateway <strong className="font-semibold text-black">Asaas</strong> para processar a cobrança.{' '}
          <strong className="font-semibold text-black">Não armazenamos</strong> o número do cartão nem o
          código de segurança em nossos sistemas.
        </p>
      </LegalSection>

      <LegalSection title="4. Para que usamos seus dados">
        <p>
          Processar pagamentos, gerir a assinatura e a cobrança, emitir documentos fiscais, prevenir
          fraude e cumprir obrigações legais.
        </p>
      </LegalSection>

      <LegalSection title="5. Base legal (LGPD)">
        <ul className="list-disc space-y-1.5 pl-5">
          <li>Execução de contrato — para processar o pagamento e prestar o serviço.</li>
          <li>Cumprimento de obrigação legal e regulatória — fiscal e contábil.</li>
          <li>Consentimento — quando aplicável, por exemplo para comunicações de marketing.</li>
        </ul>
      </LegalSection>

      <LegalSection title="6. Com quem compartilhamos">
        <p>
          Com o Asaas (operador de pagamento), com o provedor de emissão fiscal {tbd} e com
          autoridades quando exigido por lei. Não vendemos seus dados pessoais.
        </p>
      </LegalSection>

      <LegalSection title="7. Por quanto tempo guardamos">
        <p>
          Dados de cadastro e cobrança são mantidos durante a relação contratual e pelos prazos
          legais aplicáveis (fiscal e contábil) {tbd}. Dados de cartão não são retidos por nós (ver
          cláusula 3).
        </p>
      </LegalSection>

      <LegalSection title="8. Seus direitos">
        <p>
          Você pode solicitar acesso, correção, anonimização, portabilidade, eliminação e informação
          sobre o compartilhamento dos seus dados, pelo canal de contato da cláusula 1.
        </p>
      </LegalSection>

      <LegalSection title="9. Segurança">
        <p>
          Adotamos medidas técnicas e organizacionais para proteger seus dados: criptografia em
          trânsito (TLS), controle de acesso, limitação de taxa de requisições e minimização de
          dados sensíveis em registros (logs).
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
